import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  h3 {
    font-size: 24px;
    margin-top: 5px;
    color: #3f8600;
  }

  /* Novo Estilo de Listagem */
  .payments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px;
    margin-top: 25px;
  }

  .payment-card {
    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr 1fr 60px;
    gap: 15px;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(3px);
    }

    @media (max-width: 1100px) {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 14px;
        color: #333;
      }
      span {
        font-size: 11px;
        color: #008037;
        font-weight: bold;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
      }
      span {
        font-weight: 500;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
      }
    }
  }
`;

export const Card = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;

export const Table = styled.table`
  width: 100%;
  margin-top: 25px;
  border: none;
  border-collapse: separate;
  color: #001b22;
  border-spacing: 0 1em;

  thead {
    tr {
      td {
        padding: 0 15px;
        text-align: center;

        &:last-child {
          text-align: center;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        color: #001b22;
        font-size: 14px;
        height: 40px;
        padding: 0 15px;
        background: #f0f0f0;
        text-align: center;

        a {
          margin: 10px;
        }

        &:first-child {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &:last-child {
          text-align: center;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }
    }
  }
`;
